import { Component, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from '../../services/http.service';
import { AuthenService } from '../../services/authen.service';

@Component({
    selector: 'customer-master-edit',
    templateUrl: './customer-master-edit.html',
})
export class CustomerMasterEditComponent implements OnInit {
    subs: any = null;
    id: number = 0;
    item: any = null;

    constructor(private http: HttpService, private auth: AuthenService, private route: ActivatedRoute) {
        this.subs = route.params.subscribe(params => {
            this.id = params['id'];
        })
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }

    ngOnInit() {
        if (this.id > 0)
            this.load(this.id);
    }

    load(id: number) {
        this.http.get(`api/CustomerMaster/Get/${id}`, res => {
            this.item = res.Result;
        });
    }

    isInputValid() {
        let msg = null;
        if (this.item.Custname == null) {
            msg = 'Customer Name is required'
        }

        return msg;
    }

    onSave() {
        let err = this.isInputValid();
        if (err == null) {
            this.http.save('api/CustomerMaster/Save', this.item, res => {
            });
        }
    }
}
